export const OTP_METHOD = {
  EMAIL: "email",
  LINE: "line"
};